export default "__VITE_ASSET__DbOvZoU6__"